<ul
    #tabsList
    class="nav nav-tabs nav-performers"
    [ngClass]="inputclass"
    [ngStyle]="{ 'padding-right': listPadding + 'px' }"
>
    <li
        *ngFor="let conf of tabsconfig"
        class="nav-item"
        [ngClass]="conf.liclass"
        [class.active]="input === conf.activeConditionComparator"
        [class.coaching-tabs-alt-sec-active]=""
        [class.disabled]="conf.isDisabled ? conf.isDisabled() : false"
    >
        <a
            class="nav-link"
            [class.active]="input === conf.activeConditionComparator"
            (click)="
                conf.clickHandler.apply(this, conf.clickHandlerParams);
                toggleTabs()
            "
        >
            {{ conf.text }}

            <ng-container *ngIf="conf.sideTemplateRef && conf.sideContext">
                <ng-container
                    *ngTemplateOutlet="
                        conf.sideTemplateRef;
                        context: conf.sideContext
                    "
                >
                </ng-container>
            </ng-container>
        </a>
    </li>
</ul>
<div
    [hidden]="!showMore"
    #showMoreBtn
    class="x"
    (click)="toggleTabs()"
    documentBlurTrigger
    [triggerFlag]="displayMore"
    (documentBlurred)="displayMore = false"
>
    &#9776;
</div>
